export default __webpack_public_path__ + "static/media/right_comas.d26a7ced.png";